import { Injectable, NgZone } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout'
import 'rxjs/add/operator/retry'
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import { FirebaseServiceProvider } from '../../providers/firebase-service/firebase-service';
import { FIREBASE_CONFIG, GA_ID } from '../../app/app.firebase.config';
import { LoadingController, ToastController, NavController, AlertController, Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import * as firebaseApp from 'firebase/app';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { GoogleAnalytics } from '@ionic-native/google-analytics';


/*
  Generated class for the LokiDbProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/

declare var require: any;
var loki = require('lokijs');

//parte persistenza
import localforage from "localforage";


@Injectable()
export class LokiDbProvider {

    identityDB: any;
    storeDB: any;


    db: any;      // LokiJS database
    db_tmp: any;
    elementi: any;  // contiene la collezione di dati
    elementi_tmp: any;
    config: any = null;
    config_tmp: any = null;
    homePage: any = null;
    identityLMTS: any = null;
    storesLMTS: any = null;
    identityLMTS_tmp: any = null;
    storesLMTS_tmp: any = null;
    allDataLoaded = false;
    alreadyLoading = false
    alreadyCheckingForUpdate = false;
    checkUpdateTimer: number = 0;
    csdata: any = null;
    platformString = '';
    public validDomain: boolean = false;

    //nomi del db e collezioni
    private dbname: string = "ovsdb" //nome db fisso
    private collectionName: string = "tableOVS"; //nome di default di una collezione
    private keyDbOnDisk: string = "dbOnDisk" //chiave db locale salvato
    private keyConfigOnDisk: string = "config";
    private keyHomePage: string = "homePage";
    private keyValidDomain: string = "validDomain";
    private keyNotifications: string = "notifications";
    public keySaveContactAfterCall: string = "saveContactAfterCall";
    public keyPushNotificationsEnabled: string = "pushNotificationsEnabled";
    public keyOderDescendingFilter: string = "oderDescendingFilter";
    public keyOpenGmail: string = "openGmail";


    //campi di ricerca di default
    searchQuery = null;
    risultati_query: any = [];
    risultati_query_base: any = [];
    new_contacts: any = [];
    starred: any = [];
    colleagues: any = [];
    responsible: any;
    collaborators: any[] = [];
    last_searchstring = '';
    MIN_CHAR_SEARCH = 3; //num minimo di char per la ricerca
    TIMEOUT = 60000;
    RETRY_ATTEMPS = 3;
    UPDATEINTERVAL = 10 * 60000;


    //loading view
    private loading;
    private updating;


    private defaultVersion: string = "v1";
    private urlOVS: string = 'https://' + FIREBASE_CONFIG.storageBucket + "/api/";
    private getOvsLMTS: string = 'getOvsLMTS';
    private getDataForCS: string = 'getDataForCS';
    private getNotificationChannels: string = 'getNotificationChannels';
    private getPrivacy: string = "getPrivacyInfo"
    private getChatbotData: String = "getChatbotData"
    private pushNotifications: string = 'pushNotifications';
    private starStore: string = 'starStore';
    private starIdentity: string = 'starIdentity';
    private addToContacts: string = 'addToContacts';
    private favouriteSearches: string = 'favouriteSearches';
    private checkDomain: string = 'checkDomain'
    private logMessage: string = 'logMessage'
    private subscribedChannel: string = 'registerPushChannels'
    private configUrls: any[] = ['getProfiles', 'getSynonyms', 'getAvailableFilters',
        'getSearchFields', 'getConfigSettings', this.starStore, this.starIdentity,
        this.favouriteSearches, this.getNotificationChannels, this.getPrivacy];
    private configUrlsVers: any[] = [this.defaultVersion, this.defaultVersion, this.defaultVersion,
        "v2", this.defaultVersion, this.defaultVersion, this.defaultVersion,
        this.defaultVersion, this.defaultVersion, this.defaultVersion];    
    private idToken: string;

    //Notification setting
    private notificationOpt: PushOptions = {
        android: {
            icon: "icon",
            iconColor: "black",
            senderID: FIREBASE_CONFIG.messagingSenderId
        },
        ios: {
            senderID: FIREBASE_CONFIG.messagingSenderId,
            //gcmSandbox: 'true',
            alert: 'true',
            badge: 'true',
            sound: 'true'
        }
    };

    public pushObject: PushObject;
    public notifications: any[] = [];
    public expandedProfile = false;
    public expandedProfileForWidth = false;
    public processedNotifications: any[] = []
    public loggedin = false




    constructor(public http: Http, public loadingCtrl: LoadingController,
        public alertCtrl: AlertController,
        public network: NetworkConnectionProvider,
        private firebaseService: FirebaseServiceProvider,
        public translateService: TranslateService,
        private toastCtrl: ToastController,
        private push: Push,
        private platform: Platform,
        private ga: GoogleAnalytics
        //private zone: NgZone
    ) {

        localforage.config({
            driver: localforage.INDEXEDDB
            //driver: localforage.INDEXEDDB
            //INDEXEDDB sembra avere qualche probelma sui dispositivi più vecchi
        });


        this.initDataBase();


        this.platformString = platform.platforms().toLocaleString();
        //console.log("platformString -> " + this.platformString);
        try {
            window["lokidb"] = this;
        } catch (e) { }


        platform.ready().then(() => {
            //Su mobile abbiamo anche le notifiche
            this.pushInit();
            this.initGa();
        });

    }

    async swapData() {
        this.config = this.config_tmp
        this.config_tmp = null;
        this.db = this.db_tmp.copy();

        //console.info("Swap")
    }

    async getAllData() {

        if (!this.alreadyLoading) {
            this.alreadyLoading = true
            //this.presentLoadingDefault("Loading...");

            //Recupero la configurazione dallo storage
            await localforage.getItem(this.keyConfigOnDisk).then(val => {
                //console.log("tento il recupero del config da storage: " + val)
                if (val != null) {
                    this.config = val;
                }
            });


            //Recupero il db dallo storage
            let dbOnDisk = await this.importDBfromDisk();

            //Se i dati non sono consitenti li ricarico
            if (!dbOnDisk || this.config == null) {
                //recupero nuovamente tutti i dati dalla rete
                this.alreadyLoading = false
                let a = await this.getDataFromNetwork(true);
            } else {
                this.getListsOfContacts("getAllData");
                this.pushRegisterChannels();
                this.schededuleCheckForDbUpdate();
            }


            this.allDataLoaded = true
            this.alreadyLoading = false

            //se ho il loading attivo posso toglierlo
            try {
                if (this.loading) {
                    this.loading.dismiss();
                    this.loading = null;
                }
            } catch (e) {
                //console.warn("ECCCEZZIONEEEEEEEEE!!")
            }

            //Recuperare notifiche salvate in locale 
            localforage.getItem(this.keyNotifications).then(val => {
                if (val != null) {
                    this.notifications = <any[]>val;
                }
            });
            //Poi tento sempre di recuperarle dalla rete
            this.manageNotifications();
        }
    }

    getListsOfContacts(caller = "") {
        //console.log("getListsOfContacts  -> " + caller)
        this.getStarred();
        this.getNewContacts();
    }

    async getDataFromNetwork(showLoading = false) {
        //console.log("showLoading " + showLoading)
        let res = false;

        if (this.network.verifyConnection()) {

            if (firebaseApp.auth().currentUser) {
                if (this.alreadyLoading)
                    console.warn("Already loading data.");

                if (!this.alreadyLoading) {

                    let waiting
                    if (showLoading) {
                        waiting = this.loadingCtrl.create({
                            content: "Loading...",
                            duration: 15000
                        });
                        waiting.present();
                    }

                    this.allDataLoaded = false;
                    this.alreadyLoading = true

                    //Recupero la configurazione
                    res = await this.getConfigFromNetwork();
                    if (!res) {
                        return
                    }

                    res = await this.getDataForCSFromNetwork();
                    if (!res) {
                        return
                    }

                    res = await this.getContactsFromNetwork();
                    if (!res) {
                        return
                    }

                    console.time("fillDB")
                    this.fillDB()
                    console.timeEnd("fillDB")

                    //Tutte le chiamate precedenti hanno salvato i dati in strutture
                    //temporanee. Ora posso eseguire lo swap nell strutture definitive 
                    //e salvare i dati nello storage
                    console.time("swapData")
                    let resT = await this.swapData();
                    console.timeEnd("swapData")

                    if (this.updating)
                        this.updating.dismiss();

                    this.pushRegisterChannels();

                    this.manageNotifications();

                    this.getListsOfContacts("getDataFromNetwork");

                    this.schededuleCheckForDbUpdate();

                    localforage.setItem(this.keyConfigOnDisk, this.config);

                    console.time("saveDbOnDisk")
                    res = await this.saveDbOnDisk();
                    console.timeEnd("saveDbOnDisk")
                    if (!res) {
                        return
                    }

                    if (showLoading && waiting)
                        waiting.dismiss();

                    this.allDataLoaded = true;
                    this.alreadyLoading = false
                }
            }


        } else {
            this.toastCtrl.create({
                message: this.translateService.instant("NODATA_OFFLINE"),
                duration: 2000,
                position: 'top'
            }).present();
        }

    }


    getConfigFromNetwork(): Promise<boolean> {

        return new Promise(resolve => {

            for (let i in this.configUrls) {
                let u = this.configUrls[i];
                let v = this.configUrlsVers[i];
                this.getToken().then(ok => {
                    if (ok)
                        this.http.post(this.urlOVS + v +  "/" + u, null, { "headers": this.getHeaders() })
                            .timeout(this.TIMEOUT)
                            .retry(this.RETRY_ATTEMPS)
                            .map(res => res.json()).subscribe(data => {
                                if (this.config_tmp == null)
                                    this.config_tmp = new Object();

                                this.config_tmp[u] = data;

                                if ("loadedCounter" in this.config_tmp)
                                    this.config_tmp["loadedCounter"] = this.config_tmp["loadedCounter"] + 1;
                                else
                                    this.config_tmp["loadedCounter"] = 1;

                                if (this.config_tmp["loadedCounter"] >= this.configUrls.length) {
                                    this.config_tmp["ts"] = Date.now();
                                    this.config_tmp["loadedCounter"] = 0;
                                    //console.log("****Configurazione letta")
                                    console.log(this.config_tmp);
                                    resolve(true)
                                }
                            },
                            err => {
                                //resolve(false)
                                if (this.config_tmp == null)
                                    this.config_tmp = new Object();

                                if ("loadedCounter" in this.config_tmp)
                                    this.config_tmp["loadedCounter"] = this.config_tmp["loadedCounter"] + 1;
                                else
                                    this.config_tmp["loadedCounter"] = 1;

                                console.log("errore nel caricamento di " + u);
                                this.remoteLog("Errore caricamento di " + u + " - " + err);
                            });
                })
            }
        })

    }


    getDataForCSFromNetwork(): Promise<boolean> {

        return new Promise(resolve => {
            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.getDataForCS, null, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {
                            //console.log("recuperato dati per Cloud Storage");
                            this.csdata = data
                            resolve(true);
                        }, err => {
                            console.log("errore nella lettura dei dati per CS da http " + err);
                            this.remoteLog("errore nella lettura dei dati per CS da http " + err);
                            resolve(false);
                        }); //fine post
                else
                    resolve(false);
            });
        });//fine promise

    }

    getContactsFromNetwork(): Promise<boolean> {
        return new Promise(resolve => {

            let store = false;
            let identity = false;

            this.getIdentityFromNetwork().then(() => {
                identity = true;
                if (identity && store)
                    resolve(true)
            }).catch(err => {
                this.remoteLog("errore recupero contacts from network " + err);
                resolve(false);
            });

            this.getStoresFromNetwork().then(() => {
                store = true;
                if (identity && store)
                    resolve(true)
            }).catch(err => {
                this.remoteLog("errore recupero stores from network " + err);
                resolve(false);
            });
        });

    }

    getStoresFromNetwork(): Promise<boolean> {

        return new Promise(resolve => {
            this.http.get(this.csdata.stores, { "headers": this.getHeaders(this.csdata.token) })
                .timeout(this.TIMEOUT)
                .retry(this.RETRY_ATTEMPS)
                .map(res => res.json()).subscribe(data => {

                    console.log("JSON Stores -> " + data.database.length);
                    //{ "identityLMTS": "1502272613.19", "storesLMTS": 1502204404.0045383 }
                    localforage.setItem('storesLMTS', data.lastmodifyTS);

                    this.storeDB = data.database;

                    resolve(true);

                }, err => {
                    console.log("errore nel caricamento del file negozi da http " + err);
                    resolve(false);
                }); //fine post          
        });//fine promise

    }


    getIdentityFromNetwork(): Promise<boolean> {

        return new Promise(resolve => {

            this.http.get(this.csdata.identities, { "headers": this.getHeaders(this.csdata.token) })
                .timeout(this.TIMEOUT)
                .retry(this.RETRY_ATTEMPS)
                .map(res => res.json()).subscribe(data => {

                    console.log("JSON identities -> " + data.database.length);
                    localforage.setItem('identityLMTS', data.lastmodifyTS);

                    this.identityDB = data.database;

                    resolve(true);
                },
                err => {
                    console.log("errore nel caricamento del file identity da http " + err);
                    this.remoteLog("Errore recupero identity da HTTP " + err);
                    resolve(false);
                });

        });//fine promise

    }

    fillDB() {

        try {
            this.elementi_tmp.clear();

            this.identityDB.forEach(element => {
                element["sortField"] = element.order;
                element["displayName"] = element.denom;
                element = this.generateSynonymsField(element);
                this.elementi_tmp.insert(element);
            });

            this.storeDB.forEach(element => {
                element["sortField"] = element.order;
                element["displayName"] = element.denom;
                element = this.generateSynonymsField(element);
                this.elementi_tmp.insert(element);
            });

            //console.log(this.elementi_tmp)

        } catch (e) {
            console.log("Error populating identity/store database --> " + e);
            this.remoteLog("Error populating identity/store database " + e);

        }


    }


    async refreshConfig() {

        this.presentLoadingDefault("Loading config...");

        let res = await this.getConfigFromNetwork();
        if (res) {
            localforage.setItem(this.keyConfigOnDisk, this.config);
            //console.log("Salvato config nello storage");
        }

        this.loading.dismiss();

    }

    schededuleCheckForDbUpdate() {

        if (this.checkUpdateTimer != 0)
            window.clearInterval(this.checkUpdateTimer)
        else
            this.checkForDbUpdate();

        this.checkUpdateTimer = window.setInterval(() => {
            this.checkForDbUpdate();
        }, this.UPDATEINTERVAL)

        //console.log ("Timer " + this.checkUpdateTimer)

    }

    async checkForDbUpdate(force: boolean = false) {

        //this.presentLoadingDefault("Checking for update...");

        this.identityLMTS = await localforage.getItem('identityLMTS').catch(err => {
            console.log("error get: " + err);
        });
        this.storesLMTS = await localforage.getItem('storesLMTS').catch(err => {
            console.log("error get: " + err);
        });
        this.getToken().then(ok => {

            if (this.alreadyCheckingForUpdate)
                return

            this.alreadyCheckingForUpdate = true

            if (ok)
                this.http.post(this.urlOVS + this.defaultVersion + "/" + this.getOvsLMTS, null, { "headers": this.getHeaders() })
                    .timeout(this.TIMEOUT)
                    .retry(this.RETRY_ATTEMPS)
                    .map(res => res.json()).subscribe(data => {
                        //this.loading.dismiss();
                        console.log("Checking for update...");
                        //console.log(this.identityLMTS);
                        //console.log(this.storesLMTS);

                        if (force || data.identityLMTS != this.identityLMTS || data.storesLMTS != this.storesLMTS) {

                            /* Rimosso su richiesta esplicita di OVS
                            this.updating = this.toastCtrl.create({
                                message: this.translateService.instant("NEW_DB_FOUND"),
                                //duration: 2000,
                                position: 'top'
                            });
                            this.updating.present();
                            */

                            console.log("New version found. Start to update.");
                            

                            this.getDataFromNetwork(false).then(() => {
                                this.alreadyCheckingForUpdate = false
                                //Resolve();
                            }).catch((err) => {
                                this.alreadyCheckingForUpdate = false
                            });

                        } else {
                            this.alreadyCheckingForUpdate = false
                        }

                    }, (err) => {
                        console.log(err)
                        this.alreadyCheckingForUpdate = false
                        //this.loading.dismiss();
                    });
        });
    }

    addToGAL(contact) {

        return new Promise(resolve => {

            //{"contactId": "OVE95287"}
            let params = { contactId: contact.IAMid ? contact.IAMid : contact.code }
            if (contact.code) {
                params["isStore"] = "true";
            }
            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.addToContacts, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {

                            this.toastCtrl.create({
                                message: this.translateService.instant("ADDTOGAL_OK"),
                                duration: 2000,
                                position: 'top'
                            }).present();
                            resolve(true);
                        },
                        err => {

                            this.toastCtrl.create({
                                message: this.translateService.instant("ADDTOGAL_FAILED"),
                                duration: 2000,
                                position: 'top'
                            }).present();

                            console.log("errore nell'aggiunta di un cotatto alla GAL " + err);
                            resolve(false);
                        }); //fine post
            });
        });//fine promise



    }

    refreshStarred() {
        if (this.config != null) {
            this.toogleStar(null, 'S').then(() => {
                this.toogleStar(null, 'I').then(() => {
                    this.getStarred();
                });
            });
        }

    }

    toogleStar(contact, typeS = null): Promise<boolean> {

        return new Promise(resolve => {

            let path, params;
            if (contact) {
                let action = this.isStar(contact) ? 'remove' : 'add';
                if (contact.code && contact.code != '') {
                    path = this.starStore;
                    params = { [action]: [contact.code] }
                } else {
                    path = this.starIdentity;
                    params = { [action]: [contact.IAMid] }
                }
            } else {
                params = null
                if (typeS && typeS == 'S')
                    path = this.starStore;
                else
                    path = this.starIdentity;
            }

            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + path, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {
                            this.config[path] = data;
                            localforage.removeItem(this.keyConfigOnDisk).then(() => {
                                localforage.setItem(this.keyConfigOnDisk, this.config);
                                resolve(true);
                            });
                        },
                        err => {
                            console.log("errore nel set/unset di uno starred da http " + err);
                            resolve(false);
                        }); //fine post
            })
        });//fine promise
    }

    isStar(contact) {

        try {
            let params, key, path;
            if (contact.code && contact.code != '') {
                path = this.starStore;
                key = "favstores";
                params = contact.code
            } else {
                path = this.starIdentity;
                params = contact.IAMid;
                key = "favcontacts";
            }

            let t: any[] = this.config[path][key];
            return (t.indexOf(params) >= 0);

        } catch (e) {
            return false;
        }
    }

    manageSearch(s, id): Promise<boolean> {

        return new Promise(resolve => {
            //{"add": [{"search": "laura"}]}
            let path, params;
            path = this.favouriteSearches
            if (s != null && s != '') {
                params = { 'add': [{ 'search': s }] }
            } else if (id != null && id != '') {
                params = { 'remove': id }
            } else {
                resolve(true);
            }
            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + path, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {
                            this.config[path] = data;
                            localforage.removeItem(this.keyConfigOnDisk).then(() => {
                                localforage.setItem(this.keyConfigOnDisk, this.config);
                                resolve(true);
                            });
                        },
                        err => {
                            console.log("errore nella gestione delle ricerche favorite da http " + err);
                            resolve(false);
                        }); //fine post
            })
        });//fine promise
    }



    /****
     * Creazione del DB e delle collezioni
     */
    initDataBase() {
        //creiamo il db
        this.db = new loki(this.dbname);
        this.db_tmp = new loki(this.dbname + '_tmp');


        let options = {
            //indices: ['code', 'IAMid'],
            cloneObjects: true
        };

        this.elementi = this.db.addCollection(this.collectionName, options);
        this.elementi_tmp = this.db_tmp.addCollection(this.collectionName, options);


    }


    clearDatabase() {
        this.elementi.clear();
        this.elementi_tmp.clear();
    }


    hasSynonyms(f) {
        if (this.config && this.config.getSynonyms) {
            return this.config.getSynonyms.hasOwnProperty(f);
        } else {
            return false
        }
    }


    generateSynonymsField(elem) {

        let sin = {}

        //devo usare i dati nella struttura temp
        if (this.config_tmp && this.config_tmp.getSynonyms
            && typeof this.config_tmp.getSynonyms === 'object') {
            sin = this.config_tmp.getSynonyms
        } else if (this.config && this.config.getSynonyms
            && typeof this.config.getSynonyms === 'object') {
            sin = this.config.getSynonyms
        } else {
            return elem
        }

        let campi_con_sinonimi = Object.keys(sin);

        try {
            campi_con_sinonimi.forEach((x) => {
                if (sin[x].hasOwnProperty(elem[x]))
                    elem[x + '_src'] = sin[x][elem[x]].join('|');
                else
                    elem[x + '_src'] = elem[x];
            });
        } catch (e) {
            console.log("errore campi sinonimi " + e)
        }

        return elem;
    }

    /*
      Restituisce la nostra collezione di dati
    */
    private getCollection(name) {
        return this.db.getCollection(name);
    }

    /******
     * Restituisce la collezione di default
     * presa dalla var collectionName
     ******/
    public getDefaultCollection() {
        return this.getCollection(this.collectionName);
    }


    public async getNewContacts() {

        let limit = 20
        try {
            if (this.config.getConfigSettings.newContacts)
                limit = this.config.getConfigSettings.newContacts;
        } catch (e) { console.log("error " + e); }

        this.new_contacts = await this.getDefaultCollection()
            .chain().find({ 'isnew': true })
            .simplesort('insTS', true)
            .limit(limit)
            .data();

    }

    public async getStarred() {

        //console.log("getStarred")
        //console.time("getStarred")

        let ts: any[] = [];
        let ti: any[] = [];
        try {
            if (this.config[this.starStore]['favstores'] != null)
                ts = this.config[this.starStore]['favstores'];
            if (this.config[this.starIdentity]['favcontacts'] != null)
                ti = this.config[this.starIdentity]['favcontacts'];
        } catch (e) {
            console.log("errore starred " + e);
            try {
                if (this.config_tmp[this.starStore]['favstores'] != null)
                    ts = this.config_tmp[this.starStore]['favstores'];
                if (this.config_tmp[this.starIdentity]['favcontacts'] != null)
                    ti = this.config_tmp[this.starIdentity]['favcontacts'];
            } catch (e) {
                console.log("errore starred " + e);
            }
        }

        this.starred = await this.getDefaultCollection()
            .chain().find({
                '$or': [{
                    'code': { '$in': ts }
                }, {
                    'IAMid': { '$in': ti }
                }]
            })
            .simplesort('sortField')
            .data();

        if (this.starred.length > 0) {
            localStorage.setItem(this.keyHomePage, '3')
        } else {
            localStorage.setItem(this.keyHomePage, '1')
        }

        //console.timeEnd("getStarred")
    }


    getHomePage() {
        return parseInt(localStorage.getItem(this.keyHomePage))
    }

    setWelcomeVisited() {
        localStorage.setItem(this.keyHomePage, '-1')
    }

    public async getContactsByResp(c) {

        this.colleagues = [];
        this.responsible = null;
        this.collaborators = [];

        if (c.cidresp && c.cidresp != '') {
            this.colleagues = await this.getDefaultCollection()
                .chain()
                .find({ 'cidresp': c.cidresp })
                .simplesort('sortField')
                .data();

            this.responsible = await this.getDefaultCollection()
                .findOne({ 'matr': c.cidresp });
        }

        if (c.matr && c.matr != '') {
            //Estraei collaboratori (e i negozi sotto gli store manager) 
            this.collaborators = await this.getDefaultCollection().chain()
                .find({
                    '$or': [
                        { 'cidresp': c.matr }
                        //{ 'capo': c.matr }
                    ]
                }).simplesort('sortField').data();
        }

    }

    public getContactById(c) {

        //ritorna il contatto
        let p = this.getDefaultCollection().findOne({
            '$or': [
                { 'IAMid': c.IAMid },
                { 'code': c.code }
            ]
        });
        return p;
    }



    /**
     * Metodo per trovare il responsabile di un negozio e i negozi fratelli
     */
    public async getRespByNegozio(c) {
        this.colleagues = [];
        this.responsible = null;
        this.collaborators = [];

        if (c.capo && c.capo != '') {
            this.responsible = await this.getDefaultCollection().findOne({ 'matr': c.capo });

            this.colleagues = await this.getDefaultCollection().chain()
                .find({
                    '$or': [
                        //{ 'cidresp': c.capo },
                        { 'capo': c.capo }
                    ]
                }).simplesort('sortField').data();
        }

    }

    /*
      Ricerca un elemento passato come parametro in tutti i campi
      con eventuali filtri selezionati (di default sono null quindi non li utilizza)
      NB. i filtri sono in 'and' con la ricerca dei termini.
      La ricerca inizia dopo il 3 carattere (es. "abcd" o "abcdef")
      return true se trova l'elemento, false altrimenti
      NB. creato elemento Search for fix Virtual Scroll
    */
    async ricercaElemento(cerca: string, filtri = null): Promise<boolean> {

        /*********
        * funzione che restituisce stringa minuscolo,
        * utilizzata nella barra di ricerca
        *********/
        var toLower = function (str) {
            return str.toLowerCase();
        };

        cerca = cerca.trim();
        if (cerca.replace(/\*/g, "").length >= this.MIN_CHAR_SEARCH) {
            /*******
             * Separo i termini ricercati, split con space
             * converto in lower
             */
            var split_ricerca = cerca.split(" ");
            split_ricerca.map(toLower);


            if (this.last_searchstring != cerca) {

                //Memorizzo l'ultima ricerca
                this.last_searchstring = cerca;

                //Eseguo la query base e la salvo in una collection querabile
                this.risultati_query_base = await this.getDefaultCollection()
                    .chain()
                    .find(this.makeSearchQuery(split_ricerca, cerca));

            }
            //Eseguo query sulla collection salvata applicando i filtri in AND
            //altrimenti eseguo solo l'ordinamento
            if (filtri)
                this.risultati_query = await this.risultati_query_base.copy().find(filtri);//.simplesort('sortField').data();
            else
                this.risultati_query = await this.risultati_query_base.copy();//.simplesort('sortField').data();
                
            //inzio ordinamento su priorità campi di ricerca
            var enable_sorting_by_fieldPriority = true;
            if (enable_sorting_by_fieldPriority && this.risultati_query.filteredrows.length > 1) {

                //search fields raggruppati e oridinati per priorità decrescente
                var searchFields_priority = this.groupBySearchFieldsPriority();

                var tmp_risultati_query = this.risultati_query;
                this.risultati_query = [];

                for (var priority_i of searchFields_priority) {
                    //recupero da tmp_risultati_query solo gli elementi che hanno un match con i campi di ricerca i-esimi
                    let match_i = await tmp_risultati_query
                    .copy()
                    .find(this.makeMatchQuery(split_ricerca, cerca, priority_i))
                    .sort(this.sortContactsByProfilePriority())
                    .data();

                    console.log("fields: ", priority_i, "match: ", match_i);//TODO remove it
                    this.risultati_query = this.risultati_query.concat(match_i);
                }

                //elimino duplicati
                this.risultati_query = this.risultati_query.filter(function (elem, pos, arr) {
                    return arr.indexOf(elem) == pos;
                });

                //fine ordinamento
            } else {
                this.risultati_query = this.risultati_query.data();
            }

            /**
             * Verifico di aver trovato dei risultati, altrimenti restituisco
             * un oggetto vuoto con campo Search
             */
            if (this.risultati_query.length > 0) {
                return Promise.resolve(true);
            } else {
                return Promise.resolve(false);
            }


        } else {
            //console.log("nessuna ricerca..");
            return Promise.resolve(false);
        }

    }//fine ricerca elemento

    /**
     * Ripulisce il db dal disco, utile se si vuole sostituire
     */
    async clearDataFromStorage(): Promise<boolean> {
        this.clearDatabase();
        localStorage.clear();
        return localforage.clear().then(() => {

            this.toastCtrl.create({
                message: this.translateService.instant("DB_CLEAR"),
                duration: 2000,
                position: 'top'
            }).present();
            return Promise.resolve(true);

        }).catch(function (err) {
            console.log("Error ")
            this.toastCtrl.create({
                message: this.translateService.instant("DB_CLEAR_ERROR"),
                duration: 2000,
                position: 'top'
            }).present();
            return Promise.resolve(false);
        })

    }

    /**
     * Rimuove il db dal disco, utile se si vuole sostituire
     */
    async removeDataFromStorage(): Promise<boolean> {

        /******
         * Rimuovo il db dalla memoria persistente
         ******/
        let waiting = this.loadingCtrl.create({
            content: "Clearing data..."
        });
        waiting.present();

        localStorage.removeItem(this.keyHomePage);
        localStorage.removeItem(this.keyValidDomain);
        this.clearDatabase();
        const resN = await localforage.removeItem(this.keyNotifications);
        const resC = await localforage.removeItem(this.keyConfigOnDisk);

        return localforage.removeItem(this.keyDbOnDisk).then(value => {
            //console.log('Key is cleared! database non più in memoria locale');
            /*
            this.toastCtrl.create({
                message: this.translateService.instant("DB_CLEAR"),
                duration: 2000,
                position: 'top'
            }).present();
            */
            if (waiting)
                waiting.dismiss();
            return Promise.resolve(true); //andata a buon fine la rimozione del database
        }).catch(err => {
            console.log("Error rimozione del db");
            if (waiting)
                waiting.dismiss();
            this.toastCtrl.create({
                message: this.translateService.instant("DB_CLEAR_ERROR"),
                duration: 2000,
                position: 'top'
            }).present();
            return Promise.resolve(false);
        });
    }//fine remove db

    /*
    Metodo per il salvataggio del DB persistente tramite localforage
    LocalForage uses key-value maps, salva 1 valore per il db
    (the entire database)
    return true se andato a buon fine, false altrimenti
    */
    async saveDbOnDisk(): Promise<boolean> {

        const result = await localforage.setItem(this.keyDbOnDisk, JSON.stringify(this.db)).catch((err) => {
            console.log('error while saving: ');
            console.log(err);
            Promise.resolve(false)
        });

        if (result) {
            //console.log('database successfully saved ' + localforage.getItem(this.keyDbOnDisk));
            /*
            this.toastCtrl.create({
                message: this.translateService.instant("DB_SAVED_LOCAL"),
                duration: 2000,
                position: 'top'
            }).present();
            */
            return Promise.resolve(true); //il salvataggio è andato a buon fine
        } else {
            this.toastCtrl.create({
                message: this.translateService.instant("DB_SAVED_LOCAL_ERROR"),
                duration: 2000,
                position: 'top'
            }).present();
            console.log('error while saving: ');
            return Promise.resolve(false);
        }

    }//fine save db on disk

    /********
    *  Metodo per il recupero del db da memoria permanente,
    *  return true se va a buon fine, false altrimenti
    *********/
    private async importDBfromDisk(): Promise<boolean> {

        //recupero i ts dei due DB
        const retry_db = await localforage.getItem(this.keyDbOnDisk).catch((err) => {
            console.log("error get: " + err);
        });

        /****
         * Verifico il recupero del db se andato a buon fine dalla memoria persistente
        ****/
        //console.log("Carico il db in memoria");
        if (retry_db) {
            //console.log('the full database has been retrieved');
            this.db.loadJSON(retry_db);
            this.elementi = this.db.getCollection(this.collectionName);
            return Promise.resolve(true);
        } else {
            console.log('error importing database: ');
            return Promise.resolve(false);
        }

    }//fine importDB

    /******
    *   Metodo caricamento vista loading
    *******/
    private presentLoadingDefault(msg) {
        this.loading = this.loadingCtrl.create({
            content: msg
        });
        this.loading.present();
    }



    makeSearchQuery(words, fullSearch) {

        let searchFields = [];

        if (this.config && this.config.getSearchFields) {
            if (this.config.getSearchFields.stores)
                searchFields = this.config.getSearchFields.stores;

            if (this.config.getSearchFields.identity)
                searchFields = searchFields.concat(this.config.getSearchFields.identity);
        } else {
            console.log("Config corrotta")
        }  
        
        //prendo solo i campi field
        searchFields = searchFields.map((el) => { return el.field; });

        //rimuovo eventuali campi duplicati presenti sia per indentity che per negozi
        searchFields = searchFields.filter(function (elem, pos, arr) {
            return arr.indexOf(elem) == pos;
        });

        //Per i campi con sinonimi ricerco sul campo src
        searchFields = searchFields.map((x) => {
            return this.hasSynonyms(x) ? x + '_src' : x;
        });

        //Per ogni parola genero un clasola con tutti i campi in or
        var query = words.map((p) => {
            var searchRegex = this.chooseRegExp(p, fullSearch);
            var subquery = searchFields.map(function (x) {
                var o = new Object();
                o[x] = { '$regex': searchRegex }
                return o;
            });
            return { '$or': subquery }
        });
        //Le clausole generate per ogni parola vanno in and
        console.log({ '$and': query });
        return this.searchQuery = { '$and': query }
    }

    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    unionRegExp(p1: string, p2: string) {
        return "(" + this.escapeRegExp(p1) + "|" + this.escapeRegExp(p2) + ")";
    }
    chooseRegExp(p: string, fullSearch: string): RegExp {
    /* funzionalità disattivata

        if (p.startsWith("*")) {
            //ricerca: il campo 'contiene la stringa'
            return new RegExp(this.unionRegExp(p.substring(1), fullSearch), 'i');
        }
        //ricerca: il campo 'inizia con la stringa'
        return new RegExp('^' + this.unionRegExp(p, fullSearch), 'i');
    */
        //ricerca: il campo 'contiene la stringa'
        return new RegExp(this.unionRegExp(p, fullSearch), 'i');
    }

    makeMatchQuery(words, fullSearch, searchFields) {
        //prendo solo i campi field
        searchFields = searchFields.map((el) => { return el.field; });

        //Per ogni parola genero un clasola con tutti i campi in or
        var query = words.map((p) => {
            var searchRegex = this.chooseRegExp(p, fullSearch);
            var subquery = searchFields.map(function (x) {
                var o = new Object();
                o[x] = { '$regex': searchRegex }
                return o;
            });
            return { '$or': subquery }
        });
        //Le clausole generate per ogni parola vanno in OR
        //console.log({ '$or': query });
        return { '$or': query }
    }

    groupBySearchFieldsPriority(): any[] {
        if(this.config.getSearchFields.groupsByPriority)
            return this.config.getSearchFields.groupsByPriority;

        let tmp_searchFields_priority = [];
        let searchFields_priority = [];
        let searchFields = [];

        if (this.config && this.config.getSearchFields) {
            if (this.config.getSearchFields.stores)
                searchFields = this.config.getSearchFields.stores;

            if (this.config.getSearchFields.identity)
                searchFields = searchFields.concat(this.config.getSearchFields.identity);
        } else {
            console.log("Config corrotta")
        }   

        //rimuovo eventuali campi duplicati presenti sia per indentity che per negozi
        searchFields = searchFields.filter(function (elem, pos, arr) {
            return arr.map((el) => { return el.field; }).indexOf(elem.field) == pos;
        });

        //Per i campi con sinonimi ricerco sul campo src
        searchFields = searchFields.map((x) => {
            if(this.hasSynonyms(x.field)){
                let tmp = x;
                tmp.field = tmp.field + '_src'; 
                return tmp;
            }
            return x;
        });

        //raggruppo per priorità
        for (var el of searchFields) {
            let p = el.priority ? el.priority : "no_priority";
            if(! tmp_searchFields_priority[p])
            tmp_searchFields_priority[p] = [];
            
            tmp_searchFields_priority[p] = tmp_searchFields_priority[p].concat(el);
        }

        //gestione caso el senza priorità (vanno ultimi)
        searchFields_priority = tmp_searchFields_priority.filter(function(n){ return n != undefined });
        if(tmp_searchFields_priority["no_priority"])
            searchFields_priority.push(tmp_searchFields_priority["no_priority"]);
        

        console.log("groupsByPriority created:", searchFields_priority);
        this.config.getSearchFields.groupsByPriority = searchFields_priority;
        return searchFields_priority;
    }

    //funziona usata per ordinare i contatti sulla base del loro profilo
    sortContactsByProfilePriority() {
        var profiles = this.config.getProfiles;
        return function (cnt1, cnt2) {
            let man1 = cnt1.mansione;
            let man2 = cnt2.mansione;
            if (man1 != man2) {
                let pr1 = profiles.find(x => x.mansione == man1).priority;
                let pr2 = profiles.find(x => x.mansione == man2).priority;

                if (pr1 > pr2) return 1;
                if (pr1 < pr2) return -1;

            }
            //se hanno stessa mansione o pari priorità considero il campo sortField per ordinare
            return cnt1.sortField.localeCompare(cnt2.sortField);
        };
    };

    /**
      * Metodo per inserire il token nell'header e far le richieste get\post
      */
    private getHeaders(token: string = null) {

        let headers: Headers = new Headers();
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Platform', this.platformString);
        if (token != null) {
            headers.append('Authorization', token);
        } else {
            headers.append('Authorization', this.idToken);
        }
        return headers
    }

    getToken(): Promise<boolean> {
        return new Promise(resolve => {
            if (firebaseApp.auth().currentUser) {
                firebaseApp.auth().currentUser.getIdToken(false).then(idToken => {
                    this.idToken = idToken
                    resolve(true)
                });
            } else {
                console.log("Attenzione: utente non ancora loggato")
                return resolve(false)
            }
        })

    }

    async getTokenWaiter() {
        const c = await this.getToken();
    }

    checkLoginDomain(user: any = null): Promise<boolean> {
        //console.log("Method check login domain")
        return new Promise(resolve => {

            //Solo per account demo apple
            let bypass = []
            if (user != null && bypass.indexOf(user.email.toLowerCase()) >= 0) {
                localStorage.setItem(this.keyValidDomain, 'true');
                resolve(true);
            } else {
                //console.log("http check domain in progress...")
                this.getToken().then(ok => {
                    if (ok)
                        this.http.post(this.urlOVS + this.defaultVersion + '/' + this.checkDomain, null, { "headers": this.getHeaders() })
                            .timeout(this.TIMEOUT)
                            .retry(this.RETRY_ATTEMPS)
                            .map(res => res.json()).subscribe(data => {
                                //console.log("http request returned")
                                //console.log(data);
                                if (data.allowed == 'true') {
                                    localStorage.setItem(this.keyValidDomain, 'true');
                                    resolve(true);
                                } else {
                                    localStorage.setItem(this.keyValidDomain, 'false');
                                    resolve(false);
                                }
                            }, err => {
                                console.log("Enable to checkDomain from network" + err);
                                console.log("Try locally");
                                if (this.getValidDomain() == 'true') {
                                    resolve(true)
                                } else {
                                    resolve(false);
                                }
                            }); //fine post
                })
            }
        });//fine promise

    }


    getValidDomain() {
        return localStorage.getItem(this.keyValidDomain)
    }

    getConfig(): Observable<Object> {

        //if (!this.config && !this.config_tmp)
        //this.getConfig();
        return new Observable(observer => {
            observer.next(this.config);
            if (this.config == null)
                observer.complete();
        });

    }

    /*
    ***************************Gestione PUSH Notification******************************
    */


    pushInit() {
        if (!this.platform.is('core')) {

            this.pushObject = this.push.init(this.notificationOpt);

            this.pushObject.on('registration').subscribe(regid => {
                console.log("**********Registrazione push")
                console.log(regid)
            })

            this.pushObject.on('notification').subscribe((n: any) => {

                //verifico se esistono dati da aggiornare perché nelle notifiche
                //potrebbero esserci nuovi contatti che non ho in locale
                this.checkForDbUpdate()

                //Aggiorno le notifiche
                this.manageNotifications().then((ok) => {
                    try {
                        this.pushObject.finish();
                    } catch (e) {
                        console.log(e)
                    }
                });

                //Per quelle ricevute qualdo l'app è aperta
                //mostro un toast con il contenuto
                if (n.additionalData.foreground) {
                    this.toastCtrl.create({
                        message: n.message,
                        duration: 100,
                        position: 'top'
                    }).present();
                }


            });


            /*
                this.pushObject.on('notification').subscribe((n: any) => {
    
                    let processed = (this.processedNotifications.filter(x => {
                        return x == n.additionalData.notId
                    }).length) > 0;
    
                    console.log(n)
                    console.log(this.processedNotifications)
                    console.log('Already Processed -> ' + processed)
    
                    this.processedNotifications.push(n.additionalData.notId)
    
                    //Per eviate elaborazioni multiple della stessa notifica
                    //chiamo il backend solo quando l'id non è tra quelli già processati
                    if (!processed) {
    
                        this.checkForDbUpdate()
    
                        this.manageNotifications(n.additionalData.notId, 'add').then((ok) => {
                                try{
                                    this.pushObject.finish();
                                }catch(e){
                                    console.log(e)
                                }           
                        });
                    
                        //Per quelle ricevute qualdo l'app è aperta
                        //mostro un toast con il contenuto
                        if (n.additionalData.foreground) {
                            this.toastCtrl.create({
                                message: n.message,
                                duration: 100,
                                position: 'top'
                            }).present();
                        }
                    }
    
                });
            */
            this.pushObject.on('error').subscribe(error => {
                console.log('Error with Push plugin' + error)
            });
        }

    }

    pushRegisterChannels() {

        if (!this.platform.is('core') && this.isNotificationsEnabled()) {
            //Registrazione ai canali recuperati da backend
            if (this.config && this.config.getNotificationChannels
                && this.config.getNotificationChannels.channelList) {

                let channels: any[] = this.config.getNotificationChannels.channelList

                if (channels.length == 0)
                    return;

                this.subscribeChannel('add', channels).then((ok) => {
                    if (ok) {
                        let m = "All channels (" + channels.toLocaleString() + ") have been registered on backend"
                        this.remoteLog(m)
                    }
                })

                channels.forEach((x) => {
                    this.pushObject.subscribe(x).then(() => {
                        let m = "Channel " + x + " has been subscribed"
                        this.remoteLog(m)
                    }).catch((err) => {
                        console.log("Errore nella registrazione " + err)
                        this.remoteLog("Errore registrazione channel " + err);
                    });
                });
            }
        }

    }

    pushUnRegisterChannels() {

        if (!this.platform.is('core')) {
            //Registrazione ai canali recuperati da backend
            if (this.config && this.config.getNotificationChannels
                && this.config.getNotificationChannels.channelList) {

                let channels: any[] = this.config.getNotificationChannels.channelList

                //Segnalo al backend di rimuovere tutti canali al quale sono registrato
                this.subscribeChannel('purge').then((x) => {
                    if (x) {
                        let m = "All channels (" + channels.toLocaleString() + ") have been purged from backend"
                        this.remoteLog(m)
                    }
                })

                channels.forEach((x) => {
                    this.pushObject.unsubscribe(x).then(() => {
                        let m = "Channel " + x + " has been unsubscribed"
                        this.remoteLog(m)
                    }).catch((err) => {
                        console.log("Errore nella registrazione " + err)
                        this.remoteLog("Errore registrazione channel " + err);
                    });
                });
            }
        }
    }

    //Gestisce recupero, aggiunta e cancellazione delel notifiche 
    manageNotifications(notId: string = "", action: string = ""): Promise<boolean> {

        if (this.platform.is('core')) return; //lato desktop non eseguo le push

        return new Promise(resolve => {

            let params = null;
            if (notId != "" && action != "")
                params = { [action]: [notId] }
            else if (action == 'purge')
                params = { purge: "true" }


            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.pushNotifications, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {
                            //console.log("Recuperarte Notifiche");
                            //console.log(data);
                            this.notifications = this.prepareNotifications(data)
                            localforage.setItem(this.keyNotifications, this.notifications);

                            resolve(true);
                        },
                        err => {
                            console.log("errore nel caricamento delle notifiche " + err);
                            resolve(false);
                        });
            })
        });//fine promise

    }

    getHideStateOfNotificationById(nots: any[], id) {

        let t = nots.filter(n => {
            return (n.notification.data.notId == id)
        })

        return (t.length > 0 && t[0].hide ? t[0].hide : false)
    }

    prepareNotifications(nots: any[]) {

        //Ordini per TS decrescente
        nots.sort(function (a, b) {
            return b.sendTS - a.sendTS;
        });

        return nots.map(n => {
            //impostazioni per la data da visualizzare nelle notifiche, es: lun 10/03/17, 15:34
            var options = { 'weekday': 'short', 'year': '2-digit', 'month': '2-digit', 'day': '2-digit', 'hour': '2-digit', 'minute': '2-digit' };
            //console.log("vecchio formato: "+ new Date(n.sendTS * 1000));
            //console.log("nuovo formato: " + new Date(n.sendTS * 1000).toLocaleString('it-IT', { hour12: false }))
            n['dateTime'] = new Date(n.sendTS * 1000).toLocaleString('it-IT', options);
            n['hide'] = this.getHideStateOfNotificationById(this.notifications, n.notification.data.notId)
            n['read'] = (n.read == true || (n.read.toString().toLowerCase() === 'true'))
            n['body'] = n.notification.data.body != null ? n.notification.data.body : n.notification.notification.body
            //.toLocaleString('it-IT', { hour12: false });
            n['contact'] = this.getContactById(n.notification.data.customData);
            return n
        })
    }

    //Restituisce il numero di notifiche non lette
    //Viene usata per generare ul badge sul tab notification
    unreadNotifications() {
        let y = this.notifications.filter(x => { return !x.read && !x.hide }).length;
        return y

    }


    remoteLog(mes): Promise<boolean> {

        return new Promise(resolve => {

            let params = { message: [mes] }
            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.logMessage, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS).subscribe(data => {
                            console.log("remote log ->");
                            console.log(mes);
                            resolve(true);
                        },
                        err => {
                            console.log("errore durante chiamata remoteLog " + err);
                            resolve(false);
                        });
            })
        });//fine promise

    }


    subscribeChannel(action: string, channels: any[] = null): Promise<boolean> {

        return new Promise(resolve => {


            let params = null;
            if (action != "" && channels != null)
                params = { [action]: channels }
            else
                params = { purge: "true" }

            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.subscribedChannel, params, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS).subscribe(data => {
                            resolve(true);
                        },
                        err => {
                            console.log("errore durante chiamata a subscribeChannel" + err);
                            resolve(false);
                        });
            })
        });//fine promise

    }

    isAutosaveEnabled() {
        let valFromStorage = localStorage.getItem(this.keySaveContactAfterCall);

        if (valFromStorage == 'false') {
            return false
        } else {
            return true
        }
    }

    isNotificationsEnabled() {

        let valFromStorage = localStorage.getItem(this.keyPushNotificationsEnabled);

        if (valFromStorage == 'false') {
            return false
        } else {
            return true
        }
    }

    isOpenGmailEnabled() {

        let valFromStorage = localStorage.getItem(this.keyOpenGmail);

        if (valFromStorage == 'true') {
            return true
        } else {
            return false
        }
    }    

    initGa() {
        if (this.platform.is("cordova")) 
            this.ga.startTrackerWithId(GA_ID).then(() => {
                console.log('Google analytics is ready now');
            }) .catch(e => console.log('Error starting GoogleAnalytics', e));
    }


    trackUserMail(user) {
        if (this.platform.is("cordova")) {
            this.ga.setUserId(user.email);
            this.ga.trackEvent('ADB', 'userlogin', user.email);
            var t = user.email.split("@")
            var dom = ''
            if (t.length > 1) {
                dom = t[1];
            }
            this.ga.trackEvent('ADB', 'domainlogin', dom);
        } else {
            try { setTimeout("window.trackUser('" + user.email + "')", 0) } catch (e) { }
        }
    }

    trackPage(page) {
        if (this.platform.is("cordova")) {
            this.ga.trackView(page);
        } else {
            try { setTimeout("window.trackPage('" + page + "')", 0) } catch (e) { }
        }
    }


    getChatBotInfo(): Promise<object> {

        return new Promise(resolve => {

            this.getToken().then(ok => {
                if (ok)
                    this.http.post(this.urlOVS + this.defaultVersion + '/' + this.getChatbotData, null, { "headers": this.getHeaders() })
                        .timeout(this.TIMEOUT)
                        .retry(this.RETRY_ATTEMPS)
                        .map(res => res.json()).subscribe(data => {
                            resolve(data);
                        },
                        err => {
                            console.log("errore nel recupero deelle info per ilchatbot " + err);
                            resolve(null);
                        }); //fine post
            })
        });//fine promise
    }



}//fine class



// WEBPACK FOOTER //
// ./src/providers/loki-db/loki-db.ts